import { useTranslation } from 'react-i18next';
import { useEffect, useRef, useState } from 'react';
import useOnClickOutside from '../../../../hooks/useOnClickOutside';
import moment from 'moment/moment';
import Dropdown from 'react-bootstrap/Dropdown';
import Form from 'react-bootstrap/Form';
import { DateRangePicker } from 'react-date-range';
import { Col } from 'react-bootstrap';
import styled from 'styled-components';
import { addDays, isAfter } from 'date-fns';
import {ar, enUS, hi, id, th, uk, vi} from "date-fns/locale";

const MePosDateFilter = ({
                           dateRange,
                           setDateRange,
                           startDateRange,
                           subLabel = '',
                           hideSubLabel = true
                         }) => {
  const { t, i18n } = useTranslation();
  const locales = {
    uk: uk,
    vi: vi,
    ar: ar,
    hi: hi,
    id: id,
    th: th,
    en: enUS
  };

  const [isDropDown, setIsDropDown] = useState(false);
  const [selectTitle, setSelectTitle] = useState(
    `${moment().subtract(1, 'week').format('DD.MM.YY')} 
    - 
    ${moment().format('DD.MM.YY')}`);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const ref = useRef(null);
  useOnClickOutside(ref, (e) => {
    if(e.target.className.includes('calendar-trigger')) return;
    handleClose();
  });
  const [errorLabel, setErrorLabel] = useState('')

  const handleClose = () => {
    setDateRange(startDateRange);
    setIsDropDown(false);
  };

  const updateRange = (count, period) => {
    setDateRange({
      selection1: {
        startDate: moment().startOf('D').subtract(count, period).toDate(),
        endDate: moment().endOf('D').toDate(),
        key: 'selection1'
      }
    });
  };

  const handleApply = () => {
    if (dateRange.selection1.startDate !== null && dateRange.selection1.endDate!==null) {
      setSelectTitle(
        `${moment(dateRange.selection1.startDate).format('DD.MM.YY')} 
      - 
      ${moment(dateRange.selection1.endDate).format('DD.MM.YY')}`
      );
    }
    setIsDropDown(false);
  };


  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    if (!isDropDown) {
      const date = `${moment(dateRange.selection1.startDate).format('DD.MM.YY')}
      - 
      ${moment(dateRange.selection1.endDate).format('DD.MM.YY')}`
      if (date !== selectTitle) {
        setSelectTitle(date)
      }
    }
  },[dateRange, isDropDown])

  return (
    <div className="position-relative py-2 border rounder-4px">
      <DropField className={!hideSubLabel ? 'has-sub-label' : ''}>
        <Form
          onClick={() => setIsDropDown(!isDropDown)}
          className="overflow-hidden"
        >
          <Dropdown.Toggle
            className="calendar-trigger button form-select border-0 shadow-none select-input d-flex justify-content-between"
            style={{backgroundImage: 'none'}}
          >
            <div className="value-wrap">
              {selectTitle}
            </div>
            <i className='bi bi-calendar4-week ms-2 calendar-trigger cursor-pointer'></i>
          </Dropdown.Toggle>
        </Form>
        {!hideSubLabel && (
          <span
            className="fs-9 text-info position-absolute top-0 left-0 sub-label"
          >
            {t(subLabel)}
          </span>
        )}
        {isDropDown && (
          <MenuDropdown
            ref={ref}
            className="bg-white position-absolute border border-1 rounded-1 py-2 mt-3"
          >
            <div className="d-block d-lg-flex">
              <MenuItems className="overflow-hidden border-end">
                <DropdownElem onClick={() => updateRange(6, 'd')}>
                  {t('filters.7days')}
                </DropdownElem>
                <DropdownElem onClick={() => updateRange(1, 'M')}>
                  {t('filters.month')}
                </DropdownElem>
                {/*<DropdownElem onClick={() => updateRange(1, 'y')}>*/}
                {/*  {t('filters.year')}*/}
                {/*</DropdownElem>*/}
                {/*<DropdownElem onClick={(e) => updateRange(2, 'W')}>*/}
                {/*  {t('filters.custom')}*/}
                {/*</DropdownElem>*/}
                <hr className="d-lg-none my-2" />
              </MenuItems>
              <div>
                <RangeContainer className="d-flex d-lg-block justify-content-center">
                  <DateRangePicker
                    onChange={(item) => {
                      const { selection1 } = item;
                      if (isAfter(selection1.startDate, new Date())) {
                        item.selection1.startDate = new Date();
                      }

                      if (isAfter(selection1.endDate, new Date())) {
                        item.selection1.endDate = new Date();
                      }

                      const maxRange = addDays(selection1.startDate, 90);
                      if (isAfter(selection1.endDate, maxRange)) {
                        item.selection1.endDate = maxRange;
                        setErrorLabel(t('filters.calendWarning'))
                      } else {
                        setErrorLabel('')
                      }

                      setDateRange({ ...dateRange, ...item });
                    }}
                    months={2}
                    ranges={[dateRange.selection1]}
                    rangeColors={['#5842BE']}
                    direction={screenWidth > 991 ? 'horizontal' : 'vertical'}
                    showDateDisplay={false}
                    locale={locales[i18n.language] || enUS}
                    maxDate={new Date()}
                  />
                </RangeContainer>
                <hr className="my-2" />
                <div className="d-flex justify-content-center flex-column flex-lg-row align-items-center justify-content-lg-between px-3 pb-2">
                  {dateRange.selection1.startDate &&
                  dateRange.selection1.startDate ? (
                    <small className="d-block fs-7">
                      {`${moment(dateRange.selection1.startDate).format(
                        'MMMM DD, YYYY'
                      )} -
                  ${moment(dateRange.selection1.endDate).format(
                        'MMMM DD, YYYY'
                      )}`}
                    </small>
                  ) : (
                    <small>{t('filters.allPeriod')}</small>
                  )}
                </div>
              </div>
            </div>
            <div className="border-top p-3 pb-2">
              <div className='d-flex justify-content-between align-items-center'>
                <div className='opacity-50' style={{color:'red'}}>
                  {errorLabel}
                </div>
                <div className="d-flex col-6 justify-content-end g-3 gap-2">
                  <Col xs={12} lg={6}>
                    <button
                      className="w-100 d-flex justify-content-center btn clear-btn"
                      onClick={handleClose}
                    >
                      <small className="fs-7">{t('filters.cancel')}</small>
                    </button>
                  </Col>
                  <Col xs={12} lg={6}>
                    <button
                      className="w-100 d-flex justify-content-center btn apply-btn text-white btn-pos-main"
                      onClick={handleApply}
                    >
                      <small className="fs-7">{t('filters.set')}</small>
                    </button>
                  </Col>
                </div>
              </div>

            </div>
          </MenuDropdown>
        )}
      </DropField>
    </div>
  );
};

export default MePosDateFilter;


const DropField = styled(Dropdown)`
  height: 100%;
  .btn.show {
    color: #3e4957;
    background-color: white;
  }
  .dropdown-menu.show {
    /* width: 100%; */
    /* max-height: 300px;
    overflow: scroll; */
  }
  .select-input {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #3e4957;
    background-color: white;
    border: 1px solid #ced4da;
    &::after {
      display: none;
    }

    &:hover {
      color: #3e4957;
      background-color: white;
    }
  }
    
  &.has-sub-label .select-input .value-wrap,
  &.has-sub-label .select-input .icon-wrap {
      transform: translateY(9px);
  }
  &.has-sub-label .sub-label {
    font-size: 12px;
    transform: translateY(-1px);
    margin-left: 12px;
    pointer-events: none;
  }
`;

const RangeContainer = styled.div`
  .rdrDefinedRangesWrapper {
    display: none;
  }
  .rdrCalendarWrapper {
    width: 100% !important;
  }
  button {
    border: none;
  }
  .rdrMonth {
    padding-bottom: 0px;
  }
  .rdrMonthAndYearWrapper {
    padding-top: 0px;
    height: 60px;
  }
  .rdrStartEdge{
    background-color: rgb(88, 66, 190);
  }
  .rdrEndEdge {
    background-color: rgb(88, 66, 190);
  }
  .rdrDayDisabled:hover {
    cursor: default;
  }
  .rdrInRange {
    background-color: #EEECF9;
  }
  .rdrDayToday .rdrDayNumber span:after {
    background: #5842BE;
  }
  .rdrDay,
  .rdrStaticRanges {
    font-size: 14px;
  }
  .rdrWeekDay,
  .rdrMonthName {
    font-size: 14px;
    font-weight: 700;
    text-transform: capitalize;
    color: #1F3354;
  }
  .rdrMonthAndYearPickers {
    font-size: 16px;
  }
  .rdrMonthPicker {
    text-transform: capitalize;
  }
  .rdrInRange + span > span,
  .rdrInRange + span + span > span {
    color: rgb(29, 36, 41) !important;
  }
  .rdrMonthAndYearPickers select:hover,
  .rdrMonthAndYearPickers select:hover {
    background-color: rgba(88, 66, 190, .25);
  }
  .rdrDayDisabled {
    background-color: white;
  }
  [class*='rdrStartEdge'][style='color: rgb(245, 231, 248);'],
  [class*='rdrEndEdge'][style='color: rgb(245, 231, 248);'] {
    background-color: #796fef;
  }
  [class*='rdrInRange'][style='color: rgb(245, 231, 248);'] + span > span,
  [class*='rdrInRange'][style='color: rgb(179, 174, 240);'] + span > span {
    color: #1d2429 !important;
  }
  [class*='rdrInRange'][style='color: rgb(245, 231, 248);']
    + span
    + span
    > span,
  [class*='rdrInRange'][style='color: rgb(179, 174, 240);']
    + span
    + span
    > span {
    color: #1d2429 !important;
  }
  [class*='rdrStartEdge'][style='color: rgb(179, 174, 240);'],
  [class*='rdrEndEdge'][style='color: rgb(179, 174, 240);'] {
    background-color: #796fef;
  }
`;

const DropdownElem = styled.div`
  padding: 4px 16px;
  &:hover {
    background: #e9ecef;
  }
`;
const MenuItems = styled.div`
  width: 216px;
  @media (max-width: 991px) {
    width: 100%;
  }
`;

const MenuDropdown = styled.div`
  z-index: 500;
  @media (max-width: 991px) {
    width: 100%;
  }
`;